import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopBar.css';
import logo from '../../../assets/img/vivid_logo.svg';

interface TopBarProps {
  showBackButton?: boolean;
  showLogo?: boolean;
  pageName?: string;
  onBackClick?: () => void; // New optional prop for back button action
}

const TopBar: React.FC<TopBarProps> = ({ showBackButton, showLogo, pageName, onBackClick }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick(); // Use the provided function if available
    } else {
      navigate(-1); // Default action: navigate to the previous page
    }
  };

  return (
    <div className="top-bar-container">
      {showBackButton && <button className="back-button" onClick={handleBackClick} />}
      {showLogo && <img className="logo" src={logo} alt="Vivid Logo" />}
      {pageName && <h1 className="page-name">{pageName}</h1>}
    </div>
  );
};

export default TopBar;
